import {onDomReady} from "../../components/dynamic/observer";

class CallTracking {
  constructor() {
    this.sessionId = null;
    this.init();
    this.bind();
  }

  init() {
    const ctInputs = document.querySelectorAll('[data-ct-session="false"]');
    if (!ctInputs.length) {
      return;
    }

    const sessionId = this.getSessionId();
    if (!sessionId) {
      return;
    }

    ctInputs.forEach((ctInput) => {
      ctInput.value = sessionId;
      ctInput.dataset.ctSession = 'true';
    });
  }

  bind() {
    const instance = this;
    document.addEventListener('DOMContentMutated', () => {
      instance.init();
    });
  }

  getSessionId() {
    if (!this.sessionId) {
      this.sessionId = window.calltracking?.getSessionId();
    }

    return this.sessionId;
  }
}

onDomReady(() => {
  new CallTracking();
});